import { useEffect, useRef } from "react";
import Logo from "assets/svg/jetfirsat-banner-icon.svg";
import IconArrow from "assets/svg/chevron_right_black.svg";

import styles from "./styles.module.css";

const JetFirsatBanner = () => {
  const priceInfoRef = useRef(null);

  useEffect(() => {
    priceInfoRef.current = document.getElementById("fiyat-analizi");
  }, []);

  const handleClick = () => {
    if (priceInfoRef.current) {
      const wrapperHeight = priceInfoRef.current?.clientHeight || 0;
      window.scrollTo({
        top: priceInfoRef.current?.offsetTop - wrapperHeight / 2,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={styles.wrapper} onClick={handleClick}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>Jetfırsat</h3>
        <div className={styles.text}>
          Bu evin fiyatı benzer bölge ve özellikteki evlere göre <span>daha avantajlı!</span>
        </div>
      </div>
      <div className={styles.arrow}>
        <IconArrow />
      </div>
    </div>
  );
};

export default JetFirsatBanner;
